import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { PUBLIC_URL } from './config/settings/environment'
import routes from './config/settings/routes'
import NotFoundPage from './pages/NotFound'
import ListParticipants from './pages/ListParticipants'
import ManageParticipants from './pages/ManageParticipants'
import NotAllowed from './pages/NotAllowed'

/**
 * The Routing' component.
 */
const Routing = () => {
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route caseSensitive element={<NotFoundPage />} path={routes.notFound} />
        <Route caseSensitive element={<ListParticipants />} path={routes.listParticipants} />
        <Route caseSensitive element={<ManageParticipants />} path={routes.manageParticipants} />
        <Route caseSensitive element={<NotAllowed />} path={routes.notAllowed} />
        <Route element={<NotFoundPage />} path="*" />
      </Routes>
    </BrowserRouter>
  )
}

export default Routing
